// import {
//   Avatar,
//   Badge,
//   CircularProgress,
//   Divider,
//   ListItemIcon,
//   Menu,
//   MenuItem,
// } from "@mui/material";
// import { Stack } from "@mui/system";
// import React, { useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import LogoutTwoToneIcon from "@mui/icons-material/LogoutTwoTone";
// import UserAvatar from "./UseAvatar";
// import { logoutUser } from "../../Redux/authSlice";
// import { useNavigate } from "react-router-dom";
// import { stringAvatar } from "../../utils/helpers";
// import { useTheme } from "@mui/material";

// const AvatarProfile = () => {
//   const theme = useTheme();
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const user = useSelector((state) => state.auth.user);
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [hasOpened, setOpened] = useState(false);
//   const [isLoading] = useState(false);

//   const avatarMenuOpen = Boolean(anchorEl);

//   const onLogout = () => {
//     dispatch(logoutUser());
//     navigate("/login");
//   };

//   const handleClick = (event) => {
//     setAnchorEl(event.currentTarget);
//     setOpened(true);
//   };
//   const handleClose = () => {
//     setAnchorEl(null);
//   };

//   return (
//     <>
//       <Stack onClick={handleClick} sx={{ ml: "auto", cursor: "pointer" }}>
//         {!hasOpened && (
//           <Badge color="secondary" overlap="circular">
//             {/* <UserAvatar size={40} /> */}{" "}
//             <Avatar
//               {...stringAvatar(`${user.first_name} ${user.surname}`)}
//               sx={{
//                 width: 40,
//                 height: 40,
//                 boxShadow: theme.shadows[3],
//                 border: `2px solid ${theme.palette.background.paper}`,
//                 // bgcolor: theme.palette.primary.main, // Explicitly use primary for avatar bg
//                 color: theme.palette.primary.contrastText,
//               }}
//             />
//           </Badge>
//         )}
//         {/* {hasOpened && <UserAvatar size={40} />} */}
//         {hasOpened && (
//           <Avatar
//             {...stringAvatar(`${user.first_name} ${user.surname}`)}
//             sx={{
//               width: 40,
//               height: 40,
//               boxShadow: theme.shadows[3],
//               border: `2px solid ${theme.palette.background.paper}`,
//               // bgcolor: theme.palette.primary.main, // Explicitly use primary for avatar bg
//               color: theme.palette.primary.contrastText,
//             }}
//           />
//         )}
//         {isLoading && (
//           <CircularProgress sx={{ position: "absolute" }} color="secondary" />
//         )}
//       </Stack>
//       <Menu
//         id="basic-menu"
//         anchorEl={anchorEl}
//         open={avatarMenuOpen}
//         onClose={handleClose}
//         MenuListProps={{
//           "aria-labelledby": "basic-button",
//         }}
//       >
//         <Divider />
//         <MenuItem onClick={onLogout}>
//           <ListItemIcon>
//             <LogoutTwoToneIcon fontSize="small" />
//           </ListItemIcon>
//           Logout
//         </MenuItem>
//       </Menu>
//     </>
//   );
// };

// export default AvatarProfile;

// v2
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Avatar,
  Box,
  Divider,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import { stringAvatar } from "../../utils/helpers";
import { logoutUser } from "../../Redux/authSlice";

// Import icons for the menu
import LogoutIcon from "@mui/icons-material/Logout";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";

const AvatarProfile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleProfile = () => {
    handleClose();
    navigate("/dashboard"); // Or your relevant profile route
  };

  const onLogout = () => {
    handleClose(); // Close the menu first for a smoother transition
    dispatch(logoutUser());
    navigate("/login");
  };

  const fullName = [user?.first_name, user?.surname].filter(Boolean).join(" ");

  return (
    <>
      <IconButton onClick={handleClick} size="small" sx={{ ml: 2 }}>
        <Avatar {...stringAvatar(fullName)} sx={{ width: 40, height: 40 }} />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        // These props improve positioning and feel
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            width: 220,
            boxShadow: 3,
            mt: 1.5,
          },
        }}
      >
        {/* Menu Header: Confirms user identity */}
        <Box sx={{ px: 2.5, py: 1.5 }}>
          <Typography variant="subtitle1" fontWeight="bold">
            {fullName}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {user?.role}
          </Typography>
        </Box>

        <Divider />

        {/* Menu Items */}
        <MenuItem onClick={handleProfile} sx={{ my: 1 }}>
          <ListItemIcon>
            <PersonOutlineIcon fontSize="small" />
          </ListItemIcon>
          My Profile
        </MenuItem>

        <Divider />

        {/* Logout is styled as an error action for better visual cue */}
        <MenuItem onClick={onLogout} sx={{ color: "error.main" }}>
          <ListItemIcon>
            <LogoutIcon fontSize="small" sx={{ color: "error.main" }} />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </>
  );
};

export default AvatarProfile;
